module.exports = __webpack_public_path__ + "static/img/020政府建设专栏9.5c336e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/020政府建设专栏9.jpg
// module id = JV5Z
// module chunks = 0